import { createContext } from "react";

type ContextProps = {
  colorScheme: ColorScheme;
  setColorScheme: SetState<ColorScheme>;
};

export default createContext<ContextProps>({
  colorScheme: "light",
  setColorScheme: () => undefined,
});
